import template from './approve_users.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';

class ApproveUsersViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_list = ko.observableArray([]);

		   this.waiting = ko.pureComputed(() => {
			   return this.employee_list().filter(el => el.registered_status === 'waiting');
		   });
	};

	   async approve_user(v, e)
	   {
		   let data = {
			   employee_id: v.employee_id,
			   registered_status: 'approved'
		   };
		   let res = await Grape.fetches.postJSON('/employee/approve_user_access', data);
		   Utils.wrap_api_result(res, tr, () => {
			   Grape.alerts.alert({type: 'success', message: tr('Successfully approved the user. The user will now have full access to the system, in accordance to its access roles.'), title: tr('Success')});
			   this.page.updateData();
			   Navbar.updateUserApprovalCount();
		   });
	   }

	async reject_user(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('RejectUsers', {data: data});
		this.page.updateData();
		Navbar.updateUserApprovalCount();
	}

	show_approve_users_help()
	{
		Grape.dialog.open('ApproveUsersHelp', { employee_id: this.page.bindings.id });
	}
}

class ApproveUsersPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ApproveUsersViewModel(this);
	}

	init()
	{
		document.title = tr('Approve Users');
		window.current_page_title(tr('Accept And Approve Users'));
	}

	async updateData()
	{
		await this.update_employee_list();
		Utils.refresh_data_visible_roles();
	}

	   async update_employee_list()
	   {
		   let res = await Grape.fetches.getJSON('/api/record', {
			   schema: 'public',
			   table: 'employee',
			   filter: [{
				   field: 'registered_status',
				   operand: '=',
				   value: 'waiting'
			   }]
		   });

		   this.viewModel.employee_list.removeAll();
		   this.viewModel.employee_list(res?.records || []);
		   return this.viewModel.employee_list();
	   }
}

export default {
	route: '[/]admin/approve_users',
	page_class: ApproveUsersPage,
	template: template,
	template_filename: 'translation/approve_users'
};
